/**
 * Story 24.7b — `<main data-app-scroll>` (MainLayout) is THE scroller on
 * every authenticated route: the root is a bounded `h-viewport` column, so
 * `window.scrollTo` / `window.scrollY` alone do nothing there. This helper
 * scrolls the layout `<main>`, every scrolled element inside it, and the
 * window (for the routes outside MainLayout) back to the top.
 */

export const APP_SCROLL_SELECTOR = '[data-app-scroll]';

function scrollElementToTop(el: HTMLElement, behavior: ScrollBehavior): void {
  if (typeof el.scrollTo === 'function') el.scrollTo({ top: 0, behavior });
  else el.scrollTop = 0;
}

export function scrollAppContentToTop(behavior: ScrollBehavior = 'auto'): void {
  if (typeof window === 'undefined') return;
  try {
    window.scrollTo({ top: 0, behavior });
  } catch {
    // jsdom's scrollTo is a not-implemented stub in some versions.
  }
  document.querySelectorAll<HTMLElement>(APP_SCROLL_SELECTOR).forEach((main) => {
    if (main.scrollTop > 0) scrollElementToTop(main, behavior);
    main.querySelectorAll<HTMLElement>('*').forEach((el) => {
      if (el.scrollTop > 0) scrollElementToTop(el, behavior);
    });
  });
}
